const VERSION = '2.3.0';
export function getVersionString() {
    return VERSION;
}